import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=2d4bc000&scoped=true"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"
import style0 from "./tools.vue?vue&type=style&index=0&id=2d4bc000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4bc000",
  null
  
)

export default component.exports